import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Users } from "lucide-react";

const lastFirst = (a, b) => `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`);

export const VolunteersDialog = ({ ministry, members, onClose }) => {
  const [roles, setRoles] = useState({});

  useEffect(() => {
    if (!ministry) { return; }
    setRoles({});
    api.get(`/ministries/${ministry.id}/roster`).then((r) => {
      const map = {};
      (r.data || []).forEach((row) => { if (row.role && !map[row.member_id]) map[row.member_id] = row.role; });
      setRoles(map);
    }).catch(() => {});
  }, [ministry]);

  const list = ministry ? members.filter((m) => (m.ministry_ids || []).includes(ministry.id)).sort(lastFirst) : [];

  return (
    <Dialog open={!!ministry} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white max-w-md max-h-[85vh] overflow-y-auto" data-testid="volunteers-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{ministry?.name}</DialogTitle>
          <p className="flex items-center gap-1.5 text-sm text-[#2D5A27] font-medium" data-testid="volunteers-count">
            <Users className="h-4 w-4" /> {list.length} volunteer{list.length === 1 ? "" : "s"}
          </p>
        </DialogHeader>
        <ul className="divide-y divide-[#E5E0D8] border border-[#E5E0D8] rounded-xl">
          {list.map((m) => (
            <li key={m.id} className="flex items-center gap-3 px-4 py-3" data-testid={`volunteer-row-${m.id}`}>
              <div className="h-9 w-9 shrink-0 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                style={{ backgroundColor: m.avatar_color || "#2D5A27" }}>
                {(m.first_name || "?")[0]}{(m.last_name || "")[0]}
              </div>
              <div className="min-w-0">
                <p className="font-medium text-[#1C241B]">{m.first_name} {m.last_name}</p>
                <p className="text-xs text-[#7A8A78]" data-testid={`volunteer-role-${m.id}`}>{roles[m.id] || "Volunteer"}</p>
              </div>
            </li>
          ))}
          {list.length === 0 && <li className="px-4 py-8 text-center text-sm text-[#7A8A78]">No volunteers assigned yet.</li>}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
